/* eslint-disable react-hooks/rules-of-hooks */
import { useUser } from "@linkfluence/core/user/context";
import { UserPasswords } from "@linkfluence/models/user";
import { UserAPI } from "@radarly/api/users";
import {
  CreateUser,
  DiscoveryPreferencePayload,
  SearchUserRequest,
  User,
} from "@radarly/models/user";
import { UserRepository } from "./UserRepository";

export class ConnectedUserRepo implements UserRepository {
  api: UserAPI;
  public constructor() {
    this.api = new UserAPI();
  }
  public fetchCurrentUser() {
    return this.api.getCurrentUser();
  }
  public getCurrentUser() {
    return useUser() as User;
  }
  public updateCurrentUser(id: number, user: Partial<User>) {
    return this.api.updateUser(id, user);
  }
  public getUserPictures(user: number) {
    return this.api.getUserAvatars(user);
  }
  public deleteUserPicture(id: number, picture: number) {
    return this.api.deleteUserAvatar(id, picture);
  }
  public uploadUserPictures(id: number, files: File[]) {
    return this.api.uploadUserAvatars(id, files);
  }

  public closeUserBanner(banner: number) {
    return this.api.closeBanner(banner);
  }
  public updateUserPassword(id: number, passwords: UserPasswords) {
    return this.api.updatePassword(id, passwords);
  }
  public resetUserPassword(email: string) {
    return this.api.resetPassword(email);
  }
  public searchUsers(pid: number, searchUserRequest: SearchUserRequest) {
    return this.api.searchUsers(pid, searchUserRequest);
  }
  public getUser(pid: number, uid: number) {
    return this.api.getUser(pid, uid);
  }
  public createUser(user: CreateUser) {
    return this.api.createUser(user);
  }

  public getDiscoveryPreferences(pid: number, workspaceId: number) {
    return this.api.getDiscoveryPreferences(pid, workspaceId);
  }

  public updateDiscoveryPreferences(
    pid: number,
    workspaceId: number,
    params: DiscoveryPreferencePayload
  ) {
    return this.api.updateDiscoveryPreferences(pid, workspaceId, params);
  }
}
